import CollaborativeEditing from '@/constant/CollaborativeEditing'
import Events from '@/constant/Events'
import IdeasTabName from '@/constant/IdeasTabName'
import QuizStatuses from '@/constant/QuizStatuses'
import errors from '@/constant/errors'
import gaCategories from '@/constant/gaCategories'
import identityProviders from '@/constant/identityProviders'
import invitationStatus from '@/constant/invitationStatus'
import permissions from '@/constant/permissions'
import storageKeys from '@/constant/storageKeys'
import workspace from '@/constant/workspace'

const previewOpenEnded = require('@/assets/images/slide-type-preview/open-ended.svg')
const previewWordCloud = require('@/assets/images/slide-type-preview/word-cloud.svg')
const previewScale = require('@/assets/images/slide-type-preview/scales.svg')
const previewQuestion = require('@/assets/images/slide-type-preview/q&a.svg')
const previewPickAnswer = require('@/assets/images/slide-type-preview/pick-answer.svg')
const previewPickImage = require('@/assets/images/slide-type-preview/pick-image.svg')
const previewTypeAnswer = require('@/assets/images/slide-type-preview/type-answer.svg')
const previewHeading = require('@/assets/images/slide-type-preview/heading.svg')
const previewBulletPoints = require('@/assets/images/slide-type-preview/list.svg')
const previewQrcode = require('@/assets/images/slide-type-preview/qr-code.svg')
const previewImage = require('@/assets/images/slide-type-preview/image.svg')
const previewYoutube = require('@/assets/images/slide-type-preview/youtube.svg')
const previewDocument = require('@/assets/images/slide-type-preview/document.svg')
const previewGoogleSlide = require('@/assets/images/slide-type-preview/google-slides.svg')
const previewSpinnerWheel = require('@/assets/images/slide-type-preview/spinner-wheel.svg')
const previewBrainstorm = require('@/assets/images/slide-type-preview/brainstorm.svg')
const previewMatchPairs = require('@/assets/images/slide-type-preview/match-pairs.svg')
// const previewGuessNumber = require('@/assets/images/slide-type-preview/guess-number.svg')
const previewCorrectOrder = require('@/assets/images/slide-type-preview/correct-order.svg')
const previewPoll = require('@/assets/images/slide-type-preview/poll.svg')
const previewContent = require('@/assets/images/slide-type-preview/content.svg')

// Onboarding slide 2 images
const educationForm = require('@/assets/images/onboarding/slide2-education-form.svg')
const workForm = require('@/assets/images/onboarding/slide2-work-form.svg')
const communityForm = require('@/assets/images/onboarding/slide2-community-form.svg')

// Onboarding v3 images
const createOptionImage = require('@/assets/images/onboarding/blank.svg')
const uploadOptionImage = require('@/assets/images/onboarding/upload-ppt.svg')
const templatesOptionImage = require('@/assets/images/onboarding/explore-templates.svg')
const aiQuizGeneratorImage = require('@/assets/images/onboarding/ai-quiz-generator.svg')
const aiQuizGeneratorHoverImage = require('@/assets/images/onboarding/ai-quiz-generator-hover.png')

const classEn = require('@/assets/images/onboarding/class.svg')
const joyful = require('@/assets/images/onboarding/joyful.svg')
const joyfulgatherings = require('@/assets/images/onboarding/joyfulgatherings.svg')
const leaving = require('@/assets/images/onboarding/leaving.svg')
const meaningful = require('@/assets/images/onboarding/meaningful.svg')
const real = require('@/assets/images/onboarding/real.svg')
const remote = require('@/assets/images/onboarding/remote.svg')
const teambuilding = require('@/assets/images/onboarding/teambuilding.svg')
const total = require('@/assets/images/onboarding/total.svg')
const training = require('@/assets/images/onboarding/training.svg')

// Onboarding slide 1 images
const educationOptionImage = require('@/assets/images/onboarding/eduv2.svg')
const workOptionImage = require('@/assets/images/onboarding/slide1-work.svg')
const communityOptionImage = require('@/assets/images/onboarding/slide1-community.svg')
const othersOptionImage = require('@/assets/images/onboarding/slide1-others.svg')

const euRegion = 'eu'
const MASONRY_TRANSITION_DURATION = 300 // 300ms
const MIN_VOTE_IDEAS = 1
const MAX_VOTE_IDEAS = 20
const MAX_IDEAS_NUMBER = 200
const MAX_CORRECT_ORDER_OPTIONS = 7
const defaultQuestionTitle = 'Click to add question'
const defaultHeadingTitle = 'Click to add heading'

export default {
  euRegion,
  gaCategories,
  identityProviders,
  errors,
  storageKeys,
  invitationStatus,
  QuizStatuses,
  CollaborativeEditing,
  IdeasTabName,
  Events,
  workspace,
  permissions,
  MASONRY_TRANSITION_DURATION,
  MIN_VOTE_IDEAS,
  MAX_VOTE_IDEAS,
  MAX_IDEAS_NUMBER,
  MAX_CORRECT_ORDER_OPTIONS,
  allTypeSections: [
    {
      title: 'Quiz and games',
      desc: 'Ask quiz questions, or play games, and let your participants compete for victory!',
      slideTypes: [
        {
          name: 'Pick Answer',
          icon: 'fas fa-tasks',
          type: 'pickAnswer',
          slideType: null,
          desc: 'Ask a quiz question and write the options. Participants try to choose the correct answer to score points.',
          label: 'Quiz',
          ahaIcon: 'pick-answer',
          ahaIconWhite: 'pick-answer-w',
          preview: 'pickAnswer',
          previewUrl: previewPickAnswer,
        },
        {
          name: 'Pick Image',
          icon: 'fas fa-images',
          type: 'pickAnswer',
          slideType: 'imageChoice',
          desc: 'Ask a quiz question and provide image options. Participants try to choose the correct image to score points.',
          label: 'Quiz',
          ahaIcon: 'pick-image',
          ahaIconWhite: 'pick-image-w',
          preview: 'pickImage',
          previewUrl: previewPickImage,
        },
        {
          name: 'Type Answer',
          icon: 'fas fa-keyboard',
          type: 'pickAnswer',
          slideType: 'typeAnswer',
          desc: 'Ask a quiz question and write in the answer(s) that you will accept. Participants try to write the correct answer and will score points if it matches your accepted answer(s).',
          label: 'Quiz',
          ahaIcon: 'type-answer',
          ahaIconWhite: 'type-answer-w',
          preview: 'typeAnswer',
          previewUrl: previewTypeAnswer,
        },
        {
          name: 'Spinner Wheel',
          icon: 'fas fa-keyboard',
          type: 'spinnerWheel',
          desc: 'Ask quiz questions, or play games, and let your participants compete for victory!',
          label: '',
          ahaIcon: 'spinner-wheel',
          ahaIconWhite: 'spinner-wheel-w',
          preview: 'spinnerWheel',
          previewUrl: previewSpinnerWheel,
          videoTutorialUrl: 'https://www.youtube.com/embed/-PaqZrxnDOw',
        },
        {
          name: 'Match Pairs',
          type: 'pickAnswer',
          slideType: 'matchPairs',
          desc: 'Pose a question and provide prompts and answers. Participants try to match each prompt to its accompanying answer.',
          label: 'Quiz',
          ahaIcon: 'match-pairs',
          ahaIconWhite: 'match-pairs-w',
          preview: 'matchPairs',
          previewUrl: previewMatchPairs,
        },
        // {
        //   name: 'Guess Number',
        //   type: 'guessnumber',
        //   isComingSoon: true,
        //   desc: 'Pose a numerical question. Participants guess a number
        //   that’s as close as possible to the true number. Closest guess wins!',
        //   label: '',
        //   ahaIcon: 'guess-number',
        //   preview: 'guessnumber',
        //   previewUrl: previewGuessNumber,
        // },
        {
          name: 'Correct Order',
          type: 'pickAnswer',
          slideType: 'correctOrder',
          desc: 'Provide up to 10 mixed-up options and let participants order them.',
          label: 'Quiz',
          ahaIcon: 'correct-order',
          ahaIconWhite: 'correct-order-w',
          preview: 'correctorder',
          previewUrl: previewCorrectOrder,
        },
        {
          name: 'Leaderboard',
          type: 'leaderboard',
          noType: true,
        },
      ],
    },
    {
      title: 'Opinion and Q&A',
      desc: 'Collect opinions from your audience in a range of formats, or address their questions through a Q&A slide!',
      slideTypes: [

        {
          name: 'Poll',
          icon: 'fas fa-signal',
          type: 'imageChoice',
          desc: 'Pose a question, provide the options and let participants choose one or more. You can also add images',
          ahaIcon: 'multiple-choice',
          ahaIconWhite: 'multiple-choice-w',
          preview: 'poll',
          previewUrl: previewPoll,
        },
        {
          name: 'Open Ended',
          icon: 'fas fa-comment-dots',
          type: 'openEnded',
          desc: 'Pose a question and let participants freely write their responses. Set fields for participants´ names, teams, emails or avatars.',
          ahaIcon: 'open-ended',
          ahaIconWhite: 'open-ended-w',
          preview: 'openEnded',
          previewUrl: previewOpenEnded,
          videoTutorialUrl: 'https://www.youtube.com/embed/O7o7j4BZDDc',
        },
        {
          name: 'Word Cloud',
          type: 'wordCloud',
          icon: 'fas fa-cloud',
          desc: 'Pose a question and let participants write 1 or 2-word answers. The more popular an answer is, the larger it will appear on screen.',
          ahaIcon: 'word-cloud',
          ahaIconWhite: 'word-cloud-w',
          preview: 'wordCloud',
          previewUrl: previewWordCloud,
          videoTutorialUrl: 'https://www.youtube.com/embed/fAIi4n1V8yk',
        },
        {
          name: 'Scales',
          type: 'scale',
          icon: 'fas fa-sliders-h',
          desc: 'Pose a question, write statements and let your participants rate each statement on a scale. Results are shown in a colour-coded graph that shows the popularity of each statement.',
          ahaIcon: 'scales',
          ahaIconWhite: 'scales-w',
          preview: 'scale',
          previewUrl: previewScale,
        },
        {
          name: 'Q&A',
          type: 'question',
          icon: 'fas fa-comment',
          iconInside: true,
          desc: 'Participants write and vote on questions for you to answer. All questions are displayed on screen for you to address one by one. Pin questions to save them or mark as answered to remove them.',
          ahaIcon: 'qa',
          ahaIconWhite: 'q&a-w',
          preview: 'question',
          previewUrl: previewQuestion,
          videoTutorialUrl: 'https://www.youtube.com/embed/Z1kCoy9i6N0',
        },
        {
          name: 'Brainstorm',
          type: 'ideas',
          icon: 'fas fa-comment',
          iconInside: true,
          desc: 'Provide a topic and let the audience submit their ideas. Each participant votes for their favourite ideas and the results are ranked by popularity.',
          ahaIcon: 'brainstorm',
          ahaIconWhite: 'brainstorm-white',
          preview: 'brainstorm',
          previewUrl: previewBrainstorm,
          videoTutorialUrl: 'https://www.youtube.com/embed/JaxWbKImUcQ',
        },
        {
          name: 'Poll',
          icon: 'fas fa-signal',
          type: 'multipleChoice',
          desc: 'Pose a question, provide the options and let participants choose one or more. You can also add images',
          ahaIcon: 'multiple-choice',
          ahaIconWhite: 'multiple-choice-w',
          preview: 'poll',
          previewUrl: previewPoll,
          hidden: true,
        },
      ],
    },
    {
      title: 'Content slide',
      desc: 'Add text content, image, video... to your presentation',
      slideTypes: [
        {
          name: 'Content',
          type: 'freestyle',
          desc: 'Add and edit text, images and bullet points.',
          ahaIcon: 'content',
          ahaIconWhite: 'content-w',
          preview: 'content',
          previewUrl: previewContent,
        },
        {
          name: 'Heading',
          subheading: 'Subheading',
          type: 'textSlide',
          desc: 'Write a heading and an optional subheading. You can use this for introducing a question or quiz slide. This slide type also works great as an opening to a new section of the presentation.',
          ahaIcon: 'heading',
          ahaIconWhite: 'heading-w',
          preview: 'heading',
          previewUrl: previewHeading,
        },
        {
          name: 'List',
          type: 'bulletPoints',
          html: '<i class="fas fa-list bulletPoints-icon"></i>',
          desc: 'Write a bullet point list. You can also add a heading and a subheading.',
          ahaIcon: 'list',
          ahaIconWhite: 'list-w',
          preview: 'bulletPoints',
          previewUrl: previewBulletPoints,
        },
        {
          name: 'QR Code',
          type: 'qrcode',
          icon: 'fas fa-qrcode',
          desc: 'Display the unique QR code for your presentation. Participants can scan this on their devices to join your quiz. Tip: You can also show this QR code on any other slide types by clicking the top of your slide.',
          ahaIcon: 'qr-code',
          ahaIconWhite: 'qr-code-w',
          preview: 'qrcode',
          previewUrl: previewQrcode,
        },
        {
          name: 'Image',
          type: 'image',
          icon: 'far fa-image',
          desc: 'Display an image either centrally on the slide or full-screen. Use your own images or choose ones from our library.',
          ahaIcon: 'type-image',
          ahaIconWhite: 'image-w',
          preview: 'image',
          previewUrl: previewImage,
        },
        {
          name: 'YouTube',
          type: 'youtube',
          icon: 'fab fa-youtube',
          desc: 'Embed a YouTube video. Simply copy and paste the YouTube URL into the slide.',
          ahaIcon: 'youtube',
          ahaIconWhite: 'youtube-w',
          preview: 'youtube',
          previewUrl: previewYoutube,
        },

        {
          name: 'Google Slides',
          type: 'googleSlides',
          icon: 'fab fa-google',
          desc: 'Embed a Google Slides presentation. The entire slideshow will be displayed within this one slide.',
          ahaIcon: 'google-slides',
          ahaIconWhite: 'google-slides-w',
          preview: 'googleSlides',
          previewUrl: previewGoogleSlide,
        },
        {
          name: 'Document',
          type: 'document',
          icon: 'fas fa-file-import',
          desc: 'Import a PowerPoint or PDF document into this presentation.',
          ahaIcon: 'document',
          ahaIconWhite: 'document-w',
          preview: 'document',
          previewUrl: previewDocument,
          hidden: true,
        },
      ],
    },
  ],
  chartTypes: {
    bars: {
      name: 'Bars',
      icon: 'far fa-chart-bar',
      type: 'barChart',
    },
    donut: {
      name: 'Donut',
      icon: 'fas fa-chart-pie',
      type: 'donutChart',
    },
    pie: {
      name: 'Pie',
      icon: 'fas fa-chart-pie',
      type: 'pieChart',
    },
  },
  openEndedLayout: {
    grid: {
      name: 'Grid',
      icon: 'fas fa-th',
      type: 'grid',
    },
    oneByOne: {
      name: 'One by one',
      icon: 'far fa-sticky-note',
      type: 'oneByOne',
    },
  },
  additionalFields: {
    name: {
      name: 'name',
      type: 'name',
      label: 'Enter your name:',
      required: false,
      id: 1,
    },
    team: {
      name: 'team',
      type: 'team',
      label: 'Enter your organisation:',
      required: false,
      id: 2,
    },
    email: {
      name: 'email',
      type: 'email',
      label: 'Enter your email address:',
      required: false,
      id: 4,
    },
    avatar: {
      name: 'avatar',
      type: 'avatar',
      label: 'Choose an emoji as your avatar:',
      required: false,
      id: 3,
    },
  },
  audienceAdmissionFields: {
    name: {
      name: 'name',
      type: 'name',
      label: 'Enter your name:',
      required: false,
      id: 1,
      textLimit: 20,
    },
    team: {
      name: 'team',
      type: 'team',
      label: 'Enter your organisation:',
      required: false,
      id: 2,
      textLimit: 20,
    },
    email: {
      name: 'email',
      type: 'email',
      label: 'Enter your email address:',
      required: false,
      id: 3,
      textLimit: 60,
    },
  },
  colors: [
    // https://trello.com/c/383hc2zf/430-%C4%91%E1%BB%95i-list-m%C3%A0u-d%C3%B9ng-cho-c%C3%A1c-chart
    'rgba(78, 170, 241, 1)', // blue
    'rgba(255, 175, 9, 1)', // yel
    'rgba(40, 194, 112, 1)', // green
    'rgba(253, 93, 161, 1)', // pink
    'rgba(118, 105, 191, 1)', // purple
    'rgba(18, 67, 69, 1)', // dark teal
    'rgba(156, 162, 174, 1)', // grey
    'rgba(79, 151, 241, 1)', // blue 2
    'rgba(255, 199, 0, 1)', // yel 2
    'rgba(40, 194, 129, 1)', // green 2
    'rgba(253, 93, 142, 1)', // pink 2
    'rgba(127, 105, 191, 1)', // purple 2
    'rgba(37, 43, 53, 1)', // near black
    'rgba(156, 165, 174, 1)', // grey 2
    'rgba(77, 183, 240, 1)', // blue 3
    'rgba(255, 156, 16, 1)', // orange
    'rgba(40, 194, 99, 1)', // green 3
    'rgba(253, 92, 173, 1)', // pink 3
    'rgba(110, 105, 191, 1)', // purple 3
    'rgba(59, 30, 54, 1)', // dark plum
    'rgba(162, 155, 175, 1)', // grey purple
    'rgba(116, 76, 242, 1)', // purple 4
    'rgba(154, 240, 37, 1)', // neon green
    'rgba(43, 158, 195, 1)', // sky
    'rgba(253, 152, 89, 1)', // light orange
    'rgba(182, 105, 191, 1)', // weird purple
    'rgba(55, 52, 33, 1)', // some brown-green
    'rgba(155, 170, 174, 1)', // grey blue
    'rgba(74, 225, 239, 1)', // fresh blue
    'rgba(255, 100, 28, 1)', // fresh orange
  ],
  colorsHex: ['4EAAF1', '#FFAF09', '#28C270', '#FF5DA1', '#7669BF', '#124345'],
  chartDefaultData: {
    labels: ['Option 1', 'Option 2', 'Option 3'],
    values: [1, 1, 1],
    limit: 2,
  },
  defaultBaseColour: [
    {
      color: '#ffffff',
      textColour: '#313131',
    },
    {
      color: '#c9e6fd',
      textColour: '#313131',
    },
    {
      color: '#fff4da',
      textColour: '#313131',
    },
    {
      color: '#ffebf8',
      textColour: '#313131',
    },
    {
      color: '#222222',
      textColour: '#ffffff',
    },
    {
      color: '#212a4c',
      textColour: '#ffffff',
    },
    {
      color: '#541330',
      textColour: '#ffffff',
    },
  ],
  lighterColors: [
    '#c7e2f4',
    '#fce4b6',
    '#bee9cd',
    '#fbcadc',
    '#d3cfe5', // purple 1st
    '#b6c3c1',
    '#dedfe0', // 1st gray
    '#c7dcf4',
    '#fcebb6', // 2nd yellow
    '#bee9d3',
    '#fbcbd7', // 2nd pink
    '#d5cfe5', // 2nd purple
    '#bbbcbc',
    '#dee0e0', // 2nd gray
    '#c7e6f4', // 3rd blue
    '#fcddb7',
    '#bee9ca',
    '#fbcae0', // 3rd pink
    '#d1cfe5', // 3rd purple
    '#c1b8bc',
    '#e0dde0',
    '#d2c7f4',
    '#ddf7bb', // yellow green
    '#bedee7',
    '#fbdcc8',
    '#e6cee5', // last purple
    '#c0beb6',
    '#dee1e0',
    '#c7f2f3',
    '#fccdb7',
  ],
  fonts: {
    nunito: {
      value: '',
      name: 'nunito',
      label: 'Nunito (default)',
    },
    roboto: {
      url: 'https://fonts.googleapis.com/css?family=Roboto:400,700&display=swap&subset=latin-ext,vietnamese',
      value: "'Roboto', sans-serif",
      name: 'roboto',
      label: 'Roboto',
    },
    opensan: {
      url: 'https://fonts.googleapis.com/css?family=Open+Sans:400,700&display=swap&subset=latin-ext,vietnamese',
      value: "'Open Sans', sans-serif",
      name: 'opensan',
      label: 'Open Sans',
    },
    oswald: {
      url: 'https://fonts.googleapis.com/css?family=Oswald:400,700&display=swap&subset=latin-ext,vietnamese',
      value: "'Oswald', sans-serif",
      name: 'oswald',
      label: 'Oswald',
    },
    montserrat: {
      url: 'https://fonts.googleapis.com/css?family=Montserrat:400,700&display=swap&subset=latin-ext,vietnamese',
      value: "'Montserrat', sans-serif",
      name: 'montserrat',
      label: 'Montserrat',
    },
    sourceCodePro: {
      url: 'https://fonts.googleapis.com/css?family=Source+Code+Pro:400,700&display=swap&subset=latin-ext,vietnamese',
      value: "'Source Code Pro', 'Courier New', Courier, monospace",
      name: 'sourceCodePro',
      label: 'Source Code Pro',
    },
    merriweather: {
      url: 'https://fonts.googleapis.com/css?family=Merriweather:400,700&display=swap&subset=latin-ext,vietnamese',
      value: "'Merriweather', serif",
      name: 'merriweather',
      label: 'Merriweather',
    },
    ebGaramond: {
      url: 'https://fonts.googleapis.com/css?family=EB+Garamond:400,700&display=swap&subset=latin-ext,vietnamese',
      value: "'EB Garamond', serif",
      name: 'ebGaramond',
      label: 'EB Garamond',
    },
    robotoSlab: {
      url: 'https://fonts.googleapis.com/css?family=Roboto+Slab:400,700&display=swap&subset=latin-ext,vietnamese',
      value: "'Roboto Slab', serif",
      name: 'robotoSlab',
      label: 'Roboto Slab',
    },
    cairo: {
      url: 'https://fonts.googleapis.com/css?family=Cairo:400,700&display=swap&subset=arabic',
      value: "'Cairo', sans-serif",
      name: 'cairo',
      label: 'Cairo',
    },
    kanit: {
      url: 'https://fonts.googleapis.com/css?family=Kanit:400,700&display=swap&subset=thai',
      value: "'Kanit', sans-serif",
      name: 'kanit',
      label: 'Kanit',
    },
  },
  defaultQuizTeam: {
    teamCount: 5,
    teamSize: 3,
  },
  commonSlideAttributes: [
    // Background settings
    'textColour', 'visibility', 'baseColour',
    'backgroundImage', 'originBackgroundImage', 'backgroundImageCropperData',
    // Audio settings
    'audioShowControl', 'audioAutoPlay', 'audioRepeat',
    'audioPlayOnAudience', 'audioAudienceShowControl', 'audioAudienceAutoPlay',
    'audioAudienceRepeat', 'audioLink', 'audioName',
    // Type
    'type',
    // local background image cache related fields
    'backgroundCache', 'cropperDataCache', 'originBackgroundCache', 'backgroundCacheExtension',
  ],
  onboardingOptions: [
    {
      name: 'Work',
      useAhaSlidesFor: 'work',
      contentHeading: 'Make your workplace brighter…',
      formImage: workForm,
      optionImage: workOptionImage,
      customClass: 'work',
      benefits: [
        {
          heading: ' Productive meetings',
          content: 'Organise team thoughts with structured polls, ratings, brainstorms and Q&As.',
          image: meaningful,
        },
        {
          heading: 'Team building',
          content: 'Host fun team hangouts full of quizzes, engaging questions and games.',
          image: teambuilding,
        },
        {
          heading: 'Training and workshops',
          content: 'Enliven training with active participation and total attention.',
          image: training,
        },
      ],
    },
    {
      name: 'School',
      useAhaSlidesFor: 'education',
      contentHeading: 'Your learners are gonna love this…',
      formImage: educationForm,
      optionImage: educationOptionImage,
      benefits: [
        {
          heading: 'Class engagement',
          content: 'Make teaching more engaging with interactive questions, idea exchanges, and more.',
          image: classEn,
        },
        {
          heading: 'Real-time assessments',
          content: 'Create quizzes for learners to do live in-class or at home, and get instant feedback.',
          image: real,
        },
        {
          heading: 'Leaving no one behind',
          content: 'Anyone can ask questions and contribute, even anonymously.',
          image: leaving,
        },
      ],
    },
    {
      name: 'Community & Friends',
      useAhaSlidesFor: 'community',
      contentHeading: 'Bring everyone together, from anywhere…',
      formImage: communityForm,
      optionImage: communityOptionImage,
      customClass: 'community',
      benefits: [
        {
          heading: 'Joyful gatherings',
          content: 'Host a communal quiz or game night that gets people talking.',
          image: joyfulgatherings,
        },
        {
          heading: 'Meaningful talks',
          content: 'Teach and discuss through polls, idea exchanges, surveys, and more.',
          image: meaningful,
        },
        {
          heading: 'Remote connections',
          content: 'Include everyone in what you do, no matter where they are.',
          image: remote,
        },
      ],
    },
    {
      name: 'Others',
      useAhaSlidesFor: 'others',
      contentHeading: 'Find what you’re looking for…',
      formImage: educationForm,
      optionImage: othersOptionImage,
      customClass: 'others',
      benefits: [
        {
          heading: 'Total engagement',
          content: 'Raise active participation in formal or casual events through interactivity.',
          image: total,
        },
        {
          heading: 'Joyful gatherings',
          content: 'Host fun quizzes and games for small or big hangouts.',
          image: joyful,
        },
        {
          heading: 'Remote connections',
          content: 'Include everyone in what you do, no matter where they are.',
          image: remote,
        },
      ],
    },
  ],
  onboardingv3Options: [
    {
      name: 'Create',
      image: createOptionImage,
      type: 'create',
    },
    {
      name: 'Upload',
      image: uploadOptionImage,
      type: 'upload',
    },
    {
      name: 'Templates',
      image: templatesOptionImage,
      type: 'templates',
    },
    {
      name: 'AI Quiz Generator',
      image: aiQuizGeneratorImage,
      type: 'ai',
      hoverImage: aiQuizGeneratorHoverImage,
    },
  ],
  presentation: {
    defaultPresentationName: 'My new presentation',
  },
  defaultSlideTitles: [
    // leave messy structure here, in case edit content
    {
      type: 'multipleChoice',
      defaultTitle: defaultQuestionTitle,
    },
    {
      type: 'imageChoice',
      defaultTitle: defaultQuestionTitle,
    },
    {
      type: 'pickAnswer',
      defaultTitle: defaultQuestionTitle,
    },
    {
      type: 'openEnded',
      defaultTitle: defaultQuestionTitle,
    },
    {
      type: 'question',
      defaultTitle: defaultHeadingTitle,
    },
    {
      type: 'wordCloud',
      defaultTitle: defaultQuestionTitle,
    },
    {
      type: 'scale',
      defaultTitle: defaultQuestionTitle,
    },
    {
      type: 'spinnerWheel',
      defaultTitle: defaultHeadingTitle,
    },
    {
      type: 'ideas',
      defaultTitle: defaultQuestionTitle,
    },
    {
      type: 'textSlide',
      defaultTitle: defaultHeadingTitle,
    },
    {
      type: 'bulletPoints',
      defaultTitle: defaultHeadingTitle,
    },
    {
      type: 'freestyle',
      defaultTitle: defaultHeadingTitle,
    },
    {
      type: 'image',
      defaultTitle: defaultHeadingTitle,
    },
    {
      type: 'leaderboard',
      defaultTitle: 'Leaderboard',
    },
  ],
  referPublicTemplate: 'public-template',
  buttonScratch: 'scratch',
}
